export default __webpack_public_path__ + "static/media/student_portfolio.8f85f95f.png";